export enum RiskFormulaType {
  impact = 'IMPACT',
  probability = 'PROBABILITY',
  multiPart = 'MULTI_PART',
  simple = 'SIMPLE'
}
